// extracted by mini-css-extract-plugin
export default {"text":"Title_text__MWduj"};